import { __decorate } from "tslib";
import { required, email } from 'vuelidate/lib/validators';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import merchantUpdate from '@/plugins/graphql/mutations/v2/affiliate/merchant-update.gql';
import query from '@/plugins/graphql/queries/me.gql';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { MOBILE_MASK } from '@/helpers/constants/app';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import DiyRouterLeaveGuard from '@/helpers/vue_mixins/v2/DiyRouterLeaveGuard';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import { Mutation } from 'vuex-class';
import { DIY } from '@/helpers/constants/Store';
import TermsAndConditions from '@/components/v2/diy/TheDiyTerms.vue';
let AffiliateUserSignUp = class AffiliateUserSignUp extends Mixins(Mixins(FormMixin, ButtonLoaderMixin, FormValidationsMixin), ViewportSizeMixin, DiyRouterLeaveGuard, SegmentAnalyticsMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            appName: '',
            appEmail: '',
            firstName: this.me?.firstName || '',
            lastName: this.me?.lastName || '',
            mobileNumber: this.me?.contactNumber || '',
            dialCode: '+63',
            agency: '',
        };
        this.agreedToTerms = false;
    }
    get mobileMask() {
        return MOBILE_MASK;
    }
    onDialCodeChange({ dialCode }) {
        this.form.dialCode = `+${dialCode}`;
    }
    async updateUser() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            await this.signUpAffiliate();
        }
    }
    async signUpAffiliate() {
        const { firstName, lastName, mobileNumber, dialCode, agency, appName, appEmail } = this.form;
        return this.$apollo
            .mutate({
            mutation: merchantUpdate,
            variables: {
                input: {
                    userUuid: this.userUuid,
                    appName,
                    appEmail,
                    firstName,
                    lastName,
                    contactNumber: mobileNumber,
                    contactDialCode: dialCode,
                    affiliateAgency: agency,
                },
            },
        })
            .then((result) => {
            const { app } = result.data.userBaseUpdate;
            const appUuid = app.uuid;
            const serviceBundleUuid = app.serviceBundle.uuid;
            const params = {
                serviceBundleUuid,
                appUuid,
                plan: 'free_starter',
                step: '1',
                isAffiliate: 'true',
            };
            this.allowNavigation();
            this.$router.push({
                name: 'affiliate-your-facebook',
                params,
            });
        });
    }
    mounted() {
        if (this.$store.state.session.token) {
            this.$apollo
                .query({
                query,
            })
                .then((meQuery) => {
                const profile = meQuery.data.me;
                this.form.firstName = profile.firstName;
                this.form.lastName = profile.lastName;
                this.me = profile;
            });
        }
    }
};
__decorate([
    Mutation('showTerms', { namespace: DIY })
], AffiliateUserSignUp.prototype, "showTerms", void 0);
__decorate([
    Prop({ type: String, required: true })
], AffiliateUserSignUp.prototype, "userUuid", void 0);
AffiliateUserSignUp = __decorate([
    Component({
        components: {
            BaseTextField,
            ActionButton,
            TermsAndConditions,
        },
        validations: {
            form: {
                appName: { required },
                appEmail: { required, email },
                firstName: { required },
                lastName: { required },
                mobileNumber: { required },
                agency: {},
            },
        },
    })
], AffiliateUserSignUp);
export default AffiliateUserSignUp;
